import React, { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { SplashScreen } from '~shared-components/components/SplashScreen/SplashScreen'
import useAuthentication from '~shared-components/hooks/useAuthentication'
import { LoginSelector } from '~shared-components/redux/selectors/login.selector'

/**
 * The flag-readiness wait this used to do is gone with LaunchDarkly. Unleash
 * signals ready only after a successful first fetch, so waiting on it would have
 * turned an Unleash outage into a splash screen that never clears.
 */
const InternalLoader: FC<{ onReady: VoidFunction }> = ({ onReady }) => {
  const { isAuthenticated } = useAuthentication()

  const customerContextId = useSelector(LoginSelector.selectedCustomerContextId)
  const shipToLocationId = useSelector(LoginSelector.selectedLocationId)

  useEffect(() => {
    if (isAuthenticated && customerContextId && shipToLocationId) onReady()
  }, [customerContextId, isAuthenticated, onReady, shipToLocationId])

  return <SplashScreen />
}

export const PrerequisiteLoader: FC = ({ children }) => {
  const [isReady, setIsReady] = useState(false)

  if (!isReady) return <InternalLoader onReady={() => setIsReady(true)} />

  return <>{children}</>
}
